export const RENAULT_BRAND_ID = 'renault'
